import { Environment } from '@environments/model';
import { LogLevel } from '@shared/services/logs/enums';

export const environmentBase: Environment = {
  production: true,
  applicationType: 'PROD',
  allowIndexing: true,
  isCacheEnabled: true,
  isMockEnabled: false, // ⚠️ If you wanna activate the mocks in production, remember to delete the fileReplacements that correspond to the mock.ts in the angular.json file (not recommended).
  logLevel: LogLevel.ERROR,
  API: {
    endpoint: {
      default: 'https://cms.socooc.com/fournier/api',
      logs: 'https://api.socooc.com',
      elasticsearch: 'https://api.socooc.com',
      reviews: 'https://api.socooc.com',
      rdvs: 'https://api.socooc.com',
      catalogue: 'https://api.socooc.com',
      priceEstimator: 'https://api.socooc.com',
      contactEstimator: 'https://api.socooc.com',
      timeslots: 'https://api.socooc.com',
      contactB2C: 'https://api.socooc.com',
      contactB2B: 'https://api.socooc.com',
    },
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
  },
  CDN: {
    url: 'https://cdn.fourniergroupe.com',
    keepeekInstances: [
      { url: 'https://fournierrec.qd2.keepeek-dev.com', alias: 'socooc.test' },
      { url: 'https://dam.fourniergroupe.com', alias: 'socooc' },
      { url: 'https://socooc.fourniergroupe.com', alias: 'socooc' },
    ],
    maxPregenerationSize: 1200,
  },
  domains: {
    FR: {
      hostname: 'https://www.socooc.com',
      publishedLanguages: ['fr-FR'],
      searchableCountries: ['FR', 'NC', 'GF', 'GP', 'MQ', 'RE', 'PM', 'YT', 'PF', 'MF', 'TF'],
      networkId: 195,
      gtmId: 'GTM-5XP8Q5',
      didomiNoticeId: 'Y8Qep2Mh',
      espaceClientUrl: 'https://home.socooc.com',
    },
    ES: {
      hostname: 'https://www.socooc.es',
      publishedLanguages: ['es-ES'],
      searchableCountries: ['ES'],
      networkId: 193,
      gtmId: 'GTM-WCL5MK4Q',
      didomiNoticeId: 'C8nQdiYw',
      espaceClientUrl: 'https://home.socooc.es',
    },
    BE: {
      hostname: 'https://www.socooc.be',
      publishedLanguages: ['fr-BE'],
      searchableCountries: ['BE'],
      networkId: 193,
      gtmId: 'GTM-KN956WBR',
      didomiNoticeId: 'zr8Mm76m',
    },
  },
  integrations: {
    flowbox: {
      apiKey: 'jGUY_6UDQX2sdGkfKj0tPg',
    },
    googleMapsApi: {
      apiKey: 'AIzaSyAVPftZ1xG-Xd2OyCT18jeHtAzXcKJ5Lh4',
      mapId: 'dd302dd35aa20c15e3f9f2ed',
    },
    requestMetrics: {
      apiKey: 'b8xm6nb:z7hs2gg',
    },
    fournierWebservice: {
      apiKey: '<Bearer>api_a6e7344828bceaabfbb2d2844e8184dd0a55f935d686aca2725d7f4f50d2d673',
      index_models: 'indice-socooc-models',
      index_store: 'indice-socooc-store',
      index_packs: 'indice-socooc-packs',
      index_finitions: 'indice-socooc-finitions',
      index_tutos: 'indice-socooc-tutos',
      index_promotions: 'indice-socooc-promotions',
      index_blog: 'indice-socooc-blog',
      index_opportunities: 'indice-socooc-opportunity',
      index_faq: 'indice-socooc-faq',
      index_temoignages: 'indice-socooc-temoignages',
      index_sem: 'indice-socooc-sem',
      index_realisations: 'indice-socooc-realisations',
      index_mur_realisations: 'indice-socooc-mur_realisations',
      index_popins: 'indice-socooc-popin',
      index_teams: 'indice-socooc-teams',
    },
  },
  AUTH0: {
    domain: 'auth.espace-client.fourniergroupe.com',
    clientId: 'jzyPE1KzjL5viITtAgm09E1QcG9LHken',
    audience: 'https://user-service.prod.fournier.com',
  },
};
